import strings from 'utils/strings'
import { mapFrom } from 'utils/functional'

const moduleToPropNameDictionary = {
  '/BHM': strings.bhm,
  '/DASH_O': strings.rvm,
  '/CHM': strings.chm,
  '/SHM': strings.shm,
  '/EXM1': strings.exm1,
  '/EXM2': strings.exm2,
  '/EXM3': strings.exm3,
  '/SmartPlex': strings.smartplex_connector,
}

export default mapFrom(moduleToPropNameDictionary)
